import React from "react";
import styled from "styled-components";
import { LIVE_CHANNEL_STATUS_TONES } from "./liveChannelTokens";

const BadgeRoot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 58px;
  height: 20px;
  padding: 0 8px;
  border: 1px solid ${({ $tone }) => $tone.border};
  border-radius: 4px;
  background: ${({ $tone }) => $tone.background};
  color: ${({ $tone }) => $tone.text};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
  box-sizing: border-box;
`;

const resolveTone = (status) => LIVE_CHANNEL_STATUS_TONES[status] || LIVE_CHANNEL_STATUS_TONES.DEFAULT;

export default function ChannelStatusBadge({ status, className }) {
  const tone = resolveTone(status);

  return (
    <BadgeRoot className={className} $tone={tone}>
      {status || "UNKNOWN"}
    </BadgeRoot>
  );
}
